import { Component, Input } from '@angular/core';

@Component({
  selector: '[list-flat]',
  templateUrl: './list-flat.html',
  styleUrls: ['./list-flat.scss'],
})

export class ListFlat {

  /**
   * 기본 열 수
   */
  private static DEFAULT_COLS: number = 3;

  /**
   * 열 수
   */
  private cols: number = ListFlat.DEFAULT_COLS;

  /**
   * 아이템 정보 목록
   */
  list: Data[] = [];

  /**
   * 리스트 정보 바인딩
   */
  @Input('data') private set bindData(array: {
    desc: string,
    src: string,
    link: string,
  }[]) {
    if (!array || !Array.isArray(array)) {
      return;
    }

    this.list = array.map((curr) => {
      const desc = curr.desc || '';
      const src = curr.src || '';
      const link = curr.link || '';
      return new Data(desc, src, link);
    });
  }

  /**
   * 열 수 바인딩
   */
  @Input('cols') private set bindCols(cols: number) {
    const length = this.list.length;
    const rows = Math.ceil(length / cols);

    this.cols = cols > 0 ? cols : ListFlat.DEFAULT_COLS;
    this.list = this.list.map<Data>((item, idx) => {
      const rowIdx = Math.floor(idx / cols);
      return new Data(
          item.getDesc(),
          item.getSrc(),
          item.getLink(),
          idx % cols === 0,
          idx % cols === cols - 1,
          rowIdx % rows === 0,
          rowIdx % rows === rows - 1);
    });
  }

  /**
   * 리스트 아이템 너비 비율 반환
   */
  public get itemWidth(): number {
    return 100 / this.cols;
  }

  /**
   * 리스트 아이템 높이 비율 반환
   */
  public get itemHeight(): number {
    return 100 /  Math.ceil(this.list.length / this.cols);
  }

  /**
   * 링크 클릭 되었을 때 링크가 존재하면 이동, 없으면 팝업창 출력
   */
  public linkClicked(item: Data): boolean {
    return !!item.getLink();
  }
}

/**
 * 아이템 정보
 */
class Data {

  /**
   * 기본 링크 주소
   */
  private static DEFAULT_LINK: string = 'http://www.google.com/';

  /**
   * 아이템 설명
   */
  private desc: string;

  /**
   * 이미지 주소
   */
  private src: string;

  /**
   * 링크 주소
   */
  private link: string;

  /**
   * 첫 번쨰 열 여부
   */
  private isLeft: boolean;

  /**
   * 마지막 열 여부
   */
  private isRight: boolean;

  /**
   * 첫 번쨰 행 여부
   */
  private isTop: boolean;

  /**
   * 마지막 행 여부
   */
  private isBottom: boolean;

  constructor(
    desc = '-',
    src = '',
    link = Data.DEFAULT_LINK,
    isLeft = true,
    isRight = true,
    isTop = true,
    isBottom = true) {
    this.desc = desc;
    this.src = src;
    this.link = link;
    this.isLeft = isLeft;
    this.isRight = isRight;
    this.isTop = isTop;
    this.isBottom = isBottom;
  }

  /**
   * 아이템 설명
   */
  public getDesc(): string {
    return this.desc;
  }

  /**
   * 이미지 주소
   */
  public getSrc(): string {
    return this.src;
  }

  /**
   * 링크 주소
   */
  public getLink(): string {
    return this.link;
  }

  /**
   *  왼쪽 선 출력 여부
   */
  public isBorderLeft(): boolean {
    return !this.isLeft;
  }

  /**
   *  위쪽 선 출력 여부
   */
  public isBorderTop(): boolean {
    return !this.isTop;
  }

  /**
   *  첫 번째 행 여부
   */
  public isFirstRow(): boolean {
    return this.isTop && !this.isBottom;
  }

  /**
   *  첫 번째 행 여부
   */
  public isLastRow(): boolean {
    return !this.isTop && this.isBottom;
  }

  /**
   *  첫 번째 행 여부
   */
  public isFirstColumn(): boolean {
    return this.isLeft && !this.isRight;
  }

  /**
   *  첫 번째 행 여부
   */
  public isLastColumn(): boolean {
    return !this.isLeft && this.isRight;
  }
}
